import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/site';
import { categories } from '@/mocks/categories';

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="relative mt-20 border-t border-background-200 bg-gradient-to-b from-background-100 to-accent-950/45">
      <div className="mx-auto w-full px-4 py-14 md:px-10">
        <div className="flex flex-col gap-10 lg:flex-row lg:justify-between">
          <div className="max-w-md">
            <Link to="/" className="mb-4 flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-background-950">
                <i className="ri-moon-foggy-line text-xl"></i>
              </span>
              <span className="font-heading text-xl font-bold text-foreground-50">
                {siteInfo.name}
              </span>
            </Link>
            <p className="text-sm leading-relaxed text-foreground-400">{siteInfo.description}</p>
            <div className="mt-5 flex flex-wrap gap-3 text-xs text-foreground-400">
              <span className="inline-flex items-center gap-1.5 rounded-full border border-background-300/60 bg-background-200/50 px-3 py-1">
                <i className="ri-time-line text-primary-400"></i>
                {siteInfo.contactHours}
              </span>
              <span className="inline-flex items-center gap-1.5 rounded-full border border-background-300/60 bg-background-200/50 px-3 py-1">
                <i className="ri-mail-line text-primary-400"></i>
                {siteInfo.email}
              </span>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3 lg:gap-12">
            <div>
              <h4 className="mb-4 font-heading text-sm font-semibold text-foreground-100">
                热门栏目
              </h4>
              <ul className="space-y-2.5">
                {categories.slice(0, 4).map((item) => (
                  <li key={item.slug}>
                    <Link
                      to={`/category/${item.slug}`}
                      className="text-sm text-foreground-400 transition-colors hover:text-primary-400"
                    >
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="mb-4 font-heading text-sm font-semibold text-foreground-100">
                更多内容
              </h4>
              <ul className="space-y-2.5">
                {categories.slice(4).map((item) => (
                  <li key={item.slug}>
                    <Link
                      to={`/category/${item.slug}`}
                      className="text-sm text-foreground-400 transition-colors hover:text-primary-400"
                    >
                      {item.name}
                    </Link>
                  </li>
                ))}
                <li>
                  <Link
                    to="/faq"
                    className="text-sm text-foreground-400 transition-colors hover:text-primary-400"
                  >
                    常见问题
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-span-2 sm:col-span-1">
              <h4 className="mb-4 font-heading text-sm font-semibold text-foreground-100">
                关于与联系
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-foreground-400 transition-colors hover:text-primary-400"
                  >
                    关于我们
                  </Link>
                </li>
                <li>
                  <Link
                    to="/contact"
                    className="text-sm text-foreground-400 transition-colors hover:text-primary-400"
                  >
                    联系我们
                  </Link>
                </li>
                <li>
                  <Link
                    to="/contact"
                    className="text-sm text-foreground-400 transition-colors hover:text-primary-400"
                  >
                    我要投稿
                  </Link>
                </li>
                <li>
                  <Link
                    to="/contact"
                    className="text-sm text-foreground-400 transition-colors hover:text-primary-400"
                  >
                    错漏更正
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-background-300/50 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} {siteInfo.name}. 内容均为站内原创整理，转载请注明来源。</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <span>本站内容仅供参考与信息交流</span>
            <Link to="/faq" className="transition-colors hover:text-primary-400">
              内容规范
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
}